import { useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';

const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:4000';

export function useSocket(rooms = [], onEvent = {}) {
  const socketRef = useRef(null);

  useEffect(() => {
    const socket = io(WS_URL, { transports: ['websocket', 'polling'] });
    socketRef.current = socket;

    socket.on('connect', () => {
      rooms.forEach((room) => socket.emit('subscribe', room));
    });

    // Brancher les handlers passés en paramètre
    Object.entries(onEvent).forEach(([event, handler]) => {
      socket.on(event, handler);
    });

    return () => {
      socket.disconnect();
    };
    // eslint-disable-next-line
  }, []);

  const emit = useCallback((event, data) => {
    socketRef.current?.emit(event, data);
  }, []);

  return { emit };
}
